import { FC, useState } from 'react';
import { KCTLogo } from './KCTLogo';
import { navbarItemsData } from '../configs';
import { NavbarList } from './NavbarList';
import { NavbarListItem } from './NavbarListItem';
import { HamburgerButton } from './shared';
import { useDropdownLogicWithClickingOutside } from '../hooks';
import { ArrowIcon } from './ArrowIcon';
import { DropdownMenu } from './DropdownMenu';

const Navbar: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownLogic = useDropdownLogicWithClickingOutside();

  return (
    <>
      <nav className="bg-primary-default text-secondary sticky top-0 w-full z-50" ref={dropdownLogic.dropdownRef}>
        <div className="lg:container lg:mx-auto flex justify-between items-center py-1 px-4 lg:px-1">
          <KCTLogo />
          {/* Hamburger Icon (visible on small and medium screens) */}
          <HamburgerButton isOpen={isOpen} setIsOpen={setIsOpen} />
          <NavbarList isOpen={isOpen}>
            {navbarItemsData.map((item, index) => {
              const activeAndOpenDropdown: boolean = dropdownLogic.activeDropdown === item.label && dropdownLogic.isDropdownOpen
              const changeIconColor: string = activeAndOpenDropdown ? "white" : "black"
              return (
              item.children ? (
                <li 
                  key={item.label} 
                  onClick={() => dropdownLogic.toggleDropdown(item.label)} 
                  className={`relative ${activeAndOpenDropdown ? "text-white bg-primary-dark" : "text-black"} lg:rounded-md focus:outline-none lg:px-1 lg:py-3 font-medium lg:text-sm xl:text-base cursor-pointer lg:flex lg:items-center lg:justify-center`} 
                  title={item.title}
                >
                  <span className="inline-block whitespace-nowrap p-2 lg:p-0">{item.label}</span>
                  <div className={`transition-transform ${activeAndOpenDropdown ? "rotate-180" : "rotate-0"} inline-block whitespace-nowrap align-middle`}>
                    <ArrowIcon color={changeIconColor} />
                  </div>
                  <DropdownMenu item={item} activeDropdown={dropdownLogic.activeDropdown} />
                </li>
              ) : (
                <NavbarListItem key={index} item={item} setIsOpen={setIsOpen}/>
              )
            )})}
          </NavbarList>
        </div>
      </nav>
    </>
  );
};

export default Navbar;